<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Habitués" />
            <LesHabitues />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesHabitues from './LesHabitues.vue';


export default {
    name: 'MouvementPage',
    components: {
        NavBar,
        PageTitle,
        LesHabitues,
        FooterComp,
    }
}
</script>